import { CourseLicenseTemplateFilterOptions } from '@/jbi-shared/dto/jtms.dtos';
import { CourseLicenseTemplateSortColumns } from '@/jbi-shared/types/jtms.types';
import { CourseLicenseTemplateSortableHeaderOption } from './course-license-template.types';

// Create deafult filter state for trainer search components
export const initialFilterState = (): CourseLicenseTemplateFilterOptions => ({
  name: '',
  product: ''
});

// Sortable header option values specific to trainer accreditations table ONLY
export const courseLicenseTemplateSortableHeaders: CourseLicenseTemplateSortableHeaderOption[] = [
  {
    columnName: 'Course License Template Name',
    sortColumn: CourseLicenseTemplateSortColumns.NAME,
    sort: true
  },
  {
    columnName: 'Products',
    sortColumn: CourseLicenseTemplateSortColumns.PRODUCT,
    sort: true
  }
];
